// extracted by mini-css-extract-plugin
export var box = "_5b-0";
export var check = "_5b-1";
export var checkboxButton = "_5b-6";
export var checkboxGroup = "_5b-5";
export var disabled = "_5b-7";
export var ghost = "_5b-9";
export var input = "_5b-2";
export var label = "_5b-4";
export var normal = "_5b-8";
export var uncheck = "_5b-3";